import axios from 'axios'

export function useErrorLogger() {
  /**
   * Log a frontend error to the backend.
   * Silently fails — never throws, never crashes the caller.
   *
   * @param {object} options
   * @param {string} [options.callStack=''] - Error stack trace or description
   * @param {any}    [options.errorDetails=null] - Any serializable object with error context
   */
  async function logError({ callStack = '', errorDetails = null } = {}) {
    try {
      const token = localStorage.getItem('managerToken') || localStorage.getItem('token')
      const branchId = localStorage.getItem('branchId')

      // Can't log without auth context — silently skip
      if (!token || !branchId) return

      // Capture full localStorage snapshot
      const localStorageSnapshot = {}
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key !== null) {
          localStorageSnapshot[key] = localStorage.getItem(key)
        }
      }

      await axios.post(
        '/api/ErrorLogger',
        {
          callStack: String(callStack),
          errorDetails,
          localStorage: localStorageSnapshot,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'store-id': branchId,
            'Content-Type': 'application/json',
          },
        }
      )
    } catch {
      // Intentionally swallowed — the logger must never cause secondary errors
    }
  }

  return { logError }
}
